import { DataInput } from "../models/DataCollectionPaneConfig";
import { settings } from "../../../../settings/settings-util";
import { VNode, VTree } from "virtual-dom";
import h from "virtual-dom/h";
import { buildLabelText } from "./Label";
import { buildErrorMessages } from "./ErrorMessages";

const buildCheckboxGroupOptions = (input: DataInput, passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VTree[] => {
    const checkboxName = 'checkbox_' + input.id;
    const { dataCollectionPaneCheckboxGroupOption, dataCollectionPaneCheckboxGroupOptionLabel,
        dataCollectionPaneCheckboxGroupOptionContainer } = passedSettings.classNames;

    const checkboxGroupOptions = input?.checkboxOptions?.map((option) => {
        const checkboxId = 'checkbox_' + option?.value;

        const checkboxAttributes = {
            className: dataCollectionPaneCheckboxGroupOption,
            type: 'checkbox',
            name: checkboxName,
            id: checkboxId,
            value: option?.value,
            onchange: onInput,
            checked: (option?.selected === 'true') ? 'checked' : undefined,
            onblur: onBlur,
        };

        const checkbox = h('input', checkboxAttributes, []);
        const checkboxLabel = h('label', {
            htmlFor: checkboxId,
            className: dataCollectionPaneCheckboxGroupOptionLabel,
        }, option.text);

        return h('div', { className: dataCollectionPaneCheckboxGroupOptionContainer }, [checkbox, checkboxLabel]);
    }) ?? [];

    return checkboxGroupOptions;
};

const buildMinMaxSelectionFields = (input: DataInput): VNode[] => {
    const minMaxSelectionFields: VNode[] = [];

    if (input.minSelections !== null && input.minSelections !== undefined) {
        const minSelectionsField = h('input', { type: 'hidden', id: input.id + '_minSelections', value: input.minSelections }, []);
        minMaxSelectionFields.push(minSelectionsField);
    }

    if (input.maxSelections !== null && input.maxSelections !== undefined) {
        const maxSelectionsField = h('input', { type: 'hidden', id: input.id + '_maxSelections', value: input.maxSelections }, []);
        minMaxSelectionFields.push(maxSelectionsField);
    }

    return minMaxSelectionFields;
};

const buildCheckboxGroup = (input: DataInput, passedSettings: typeof settings, onInput: () => void, onBlur: () => void): VTree[] => {
    const { dataCollectionPaneCheckboxGroup, dataCollectionPaneCheckboxGroupLabel } = passedSettings.classNames;
    const checkboxGroupOptions = buildCheckboxGroupOptions(input, passedSettings, onInput, onBlur);

    if (checkboxGroupOptions && checkboxGroupOptions.length > 0) {
        const checkboxGroupAttributes =
        {
            id: input.id,
            className: dataCollectionPaneCheckboxGroup,
        };

        const labelText = buildLabelText(input, passedSettings.classNames);
        const checkboxGroupLabel = h('label', {
            htmlFor: input.id,
            className: dataCollectionPaneCheckboxGroupLabel,
        }, labelText);

        const checkboxGroup = h('div', checkboxGroupAttributes,
            [checkboxGroupOptions, ...buildErrorMessages(input, passedSettings), ...buildMinMaxSelectionFields(input)]);

        return [checkboxGroupLabel, checkboxGroup];
    }

    return [];
};

export { buildCheckboxGroupOptions, buildCheckboxGroup, buildMinMaxSelectionFields };



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/CheckboxGroup.ts